import React from 'react';
import { Send, Check } from 'lucide-react';

const Contact: React.FC = () => {
  return (
    <div className="animate-fade-in">
      {/* Hero */}
      <section className="section bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl mb-6">
              Let's Grow Your Practice Together
            </h1>
            <p className="text-xl text-gray-600">
              Schedule a demo with our team to learn how we can help you attract and retain more high-value clients.
            </p>
          </div>
        </div>
      </section>
      
      {/* Calendly Section */}
      <section className="section pt-0">
        <div className="container-custom">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <iframe
              src="https://calendly.com/advisorgrow-savemyretirement"
              width="100%"
              height="800"
              frameBorder="0"
              title="Schedule a demo"
              className="w-full"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;